import TemplateCn002 from './TemplateCn002';
import TemplateCn004 from './TemplateCn004';
import TemplateCn005 from './TemplateCn005';
import TemplateCn007 from './TemplateCn007';
import TemplateCn008 from './TemplateCn008';
import TemplateCn009 from './TemplateCn009';
import TemplateCn010 from './TemplateCn010';
import TemplateCn012 from './TemplateCn012';
import TemplateCn014 from './TemplateCn014';
import TemplateCn016 from './TemplateCn016';
import TemplateCn017 from './TemplateCn017';
import TemplateCn021 from './TemplateCn021';
import TemplateCn023 from './TemplateCn023';
import TemplateCn026 from './TemplateCn026';
import TemplateCn027 from './TemplateCn027';
import TemplateCn037 from './TemplateCn037';
import TemplateCn044 from './TemplateCn044';
import TemplateCn053 from './TemplateCn053';
import TemplateCn061 from './TemplateCn061';
import TemplateCn063 from './TemplateCn063';
import TemplateCn065 from './TemplateCn065';
import TemplateCn069 from './TemplateCn069';
import TemplateCn071 from './TemplateCn071';
import TemplateCn109 from './TemplateCn109';
import TemplateCn113 from './TemplateCn113';
import TemplateCn116 from './TemplateCn116';
import TemplateCn118 from './TemplateCn118';
import TemplateCn129 from './TemplateCn129';
import TemplateCn161 from './TemplateCn161';

export const realTemplateComponents: Record<string, React.FC<{ data: import('@/types').ResumeData; theme: import('@/types').TemplateTheme }>> = {
  'cn-002': TemplateCn002,
  'cn-004': TemplateCn004,
  'cn-005': TemplateCn005,
  'cn-007': TemplateCn007,
  'cn-008': TemplateCn008,
  'cn-009': TemplateCn009,
  'cn-010': TemplateCn010,
  'cn-012': TemplateCn012,
  'cn-014': TemplateCn014,
  'cn-016': TemplateCn016,
  'cn-017': TemplateCn017,
  'cn-021': TemplateCn021,
  'cn-023': TemplateCn023,
  'cn-026': TemplateCn026,
  'cn-027': TemplateCn027,
  'cn-037': TemplateCn037,
  'cn-044': TemplateCn044,
  'cn-053': TemplateCn053,
  'cn-061': TemplateCn061,
  'cn-063': TemplateCn063,
  'cn-065': TemplateCn065,
  'cn-069': TemplateCn069,
  'cn-071': TemplateCn071,
  'cn-109': TemplateCn109,
  'cn-113': TemplateCn113,
  'cn-116': TemplateCn116,
  'cn-118': TemplateCn118,
  'cn-129': TemplateCn129,
  'cn-161': TemplateCn161,
};